import { createSlice } from '@reduxjs/toolkit';

import { apiHostname, METAL_ABBR, PriceSources } from 'shared/constants';
import { AlphamartHttpError } from 'shared/types';
import {
  GenericStoreReducer,
  GenericStoreSlice,
  GenericThunk,
  getGenericReducers,
} from './shared/createGenericStoreSlice';

const changePriceSourceSlice = createSlice<
  GenericStoreSlice,
  GenericStoreReducer<GenericStoreSlice>
>({
  name: 'changePriceSource',
  initialState: { error: undefined },
  reducers: {
    ...getGenericReducers(),
  },
});

export const { success, failure, pending: submitting } = changePriceSourceSlice.actions;

export default changePriceSourceSlice.reducer;

export const changePriceSource =
  (metal: METAL_ABBR, source: PriceSources, hedge?: number): GenericThunk =>
  async (dispatch, getState, httpClient) => {
    try {
      dispatch(submitting());
      await httpClient.patch(`${apiHostname}/api/me/prices`, {
        [`${metal}PriceSource`]: source,
        ...(hedge && { [`${metal}HedgeUsed`]: hedge }),
      });
      dispatch(success({}));
    } catch (err) {
      dispatch(failure((err as AlphamartHttpError)?.response?.data?.message));
      throw err;
    }
  };
